// layout.js
import { Events } from "./events.js";

export const Layout = {
    _dotNetRef: null,
    _isConnected: true,

    bindLiveStatus(dotNetRef) {
        this._dotNetRef = dotNetRef;

        this._updateStatus(true);
        this._updateQuality('good');

        Events.on("workflow:liveConnected", () => {
            this._updateStatus(true);
        });

        Events.on("workflow:liveDisconnected", () => {
            this._updateStatus(false);
        });

        Events.on("conn:qualityChanged", quality => {
            this._updateQuality(quality);
        });

        window.addEventListener('online', () => this._updateStatus(true));
        window.addEventListener('offline', () => this._updateStatus(false));

        this._observeBlazorReconnect();
        this._startHealthCheck();
    },

    _updateStatus(connected) {
        this._isConnected = connected;
        if (this._dotNetRef) {
            try {
                this._dotNetRef.invokeMethodAsync('SetLiveStatus', connected);
            } catch { }
        }
    },

    _updateQuality(quality) {
        if (this._dotNetRef) {
            try {
                this._dotNetRef.invokeMethodAsync('SetConnectionQuality', quality);
            } catch { }
        }
    },

    _observeBlazorReconnect() {
        const observer = new MutationObserver(() => {
            const modal = document.getElementById('components-reconnect-modal');
            if (modal) {
                const isVisible = modal.style.display !== 'none' ||
                    modal.classList.contains('components-reconnect-show');
                if (isVisible) {
                    this._updateStatus(false);
                    this._updateQuality('offline');
                }
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style']
        });
    },

    _startHealthCheck() {
        setInterval(() => {
            if (!this._isConnected) return;

            const start = performance.now();
            fetch('/health', { method: 'GET', cache: 'no-store' })
                .then(response => {
                    if (!response.ok) throw new Error('Health check failed');
                    const latency = performance.now() - start;

                    let quality = 'good';
                    if (latency > 500) quality = 'poor';
                    else if (latency > 200) quality = 'fair';

                    this._updateQuality(quality);
                    this._updateStatus(true);
                })
                .catch(() => {
                    this._updateQuality('offline');
                    this._updateStatus(false);
                });
        }, 15000);
    }
};
